import React, { Fragment, useState } from 'react'
import { useAuth } from "hooks/use-auth";
import { useForm, SubmitHandler } from "react-hook-form";
import { FormLabel, FormInput, FormLabelInputWrapper, ModalSubmit, LoadingContainer } from 'styles/styles';
import { CircularProgress } from '@mui/material';
import config from 'config';

interface CognitoPasswordDataProps {
	current_password: string,
	new_password: string
}

export const CognitoSetPassword = () => {
	const auth = useAuth();
	const [isSubmitDisable, setIsSubmitDisable] = useState<boolean>(false);

	//modal
	const { reset, register, handleSubmit, watch, setValue, formState: { errors } } = useForm<CognitoPasswordDataProps>();
	const onSubmit: SubmitHandler<CognitoPasswordDataProps> = async (submitData: CognitoPasswordDataProps) => {
		setIsSubmitDisable(true);
		const res = await auth.changePassword(submitData.current_password, submitData.new_password);
		window.alert(res.message);
		setIsSubmitDisable(false);
	}
	//modal end

	//arrayの生成
	const parentArray = [
		{ title: '今のパスワード', field: 'current_password', type: 'password', required: true },
		{ title: '新しいパスワード', field: 'new_password', type: 'password', required: true }]

	const listItems = parentArray.map((element: any, index) => {
		if (element.title) {
			return (
				<Fragment key={index}>
					<FormLabelInputWrapper>
						<FormLabel htmlFor={element.field}>{element.title}</FormLabel>
						<FormInput {...register(element.field)}
							{...(element.type && { type: config.inputErrorMessage[element.type].type })}
							{...(element.required && { required: true })}
						/>
					</FormLabelInputWrapper>
				</Fragment>
			)
		}
	});


	return (
		<>
			<p>パスワードを変更する場合は、今のパスワードと新しいパスワードを入力してください。</p>
			<form onSubmit={handleSubmit(onSubmit)}>
				{listItems}
				{isSubmitDisable ? (
					<LoadingContainer>
						<CircularProgress size={20} />
					</LoadingContainer>
				) : (
					<ModalSubmit type="submit" disabled={isSubmitDisable} />
				)}
			</form>
		</>
	)
}